import { createAsyncActionType } from './index';

export const PUBLIC_PAGE_DATA_GET = createAsyncActionType(
  'public',
  'PUBLIC_PAGE_DATA_GET'
);
export const PUBLIC_PAGE_DETAILS_GET = createAsyncActionType(
  'public',
  'PUBLIC_PAGE_DETAILS_GET'
);
